import { render, staticRenderFns } from "./WInlineText.vue?vue&type=template&id=812e1f7c&scoped=true&"
import script from "./WInlineText.vue?vue&type=script&setup=true&lang=js&"
export * from "./WInlineText.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./WInlineText.vue?vue&type=style&index=0&id=812e1f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812e1f7c",
  null
  
)

export default component.exports